// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieSettings_container__ln76X","buttons":"CookieSettings_buttons__YlP0h"};